export default "__VITE_ASSET__250a3811__"